import React, { Component } from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import {
  withStyles,
  TextField,
  MenuItem,
  Button,
} from '@material-ui/core';
import {
  CommonPanel,
} from 'components';
import NumberFormat from 'react-number-format';

import styles from './styles';

import BuildingTypePicker from './components/BuildingTypePicker';

class NtkFilters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  onChange(e) {
    const { handleChange, versions } = this.props;
    const data = {
      name: e.target.name,
      value: e.target.value,
    };

    if (!handleChange) {
      return;
    }

    // Set object as pricing value
    if (data.name === 'pricing') {
      data.value = _.find(versions, { code: data.value }) || '';
    }

    handleChange(data);
  }

  componentDidUpdate() {
    const { pricing, versions, handleChange, type, types } = this.props;

    if (!handleChange) {
      return;
    }

    if (!pricing && versions && versions.length > 0) {
      handleChange({
        name: 'pricing',
        value: _.first(versions),
      })
    }

    if (!type && (types && types.length)) {
      handleChange({
        name: 'type',
        value: _.first(types).code,
      })
    }
  }

  renderUserInputs() {
    const {
      classes,
      title,
      unit,
      amount,
      pricing,
      type,
      buildingType,
      handleClearForm,
      handleSaveForm,
      t,
    } = this.props;

    if (!pricing || !type || !buildingType) {
      return;
    }

    return (
      <div>
        
        <NumberFormat
          required
          fullWidth
          customInput={TextField}
          allowNegative={false}
          isNumericString
          className={classes.textField}
          label={<span>Įveskite kiekį, {unit || '-'}</span>}
          onBlur={this.onChange.bind(this)}
          onFocus={e => e.target.select()}
          name="amount"
          value={amount}
          margin="dense"
          variant="outlined"
        />

        <TextField
          fullWidth
          multiline
          className={classes.textField}
          label={t('Pastabos')}
          onChange={this.onChange.bind(this)}
          name="title"
          value={title}
          margin="dense"
          variant="outlined"
        />

        <Button
          fullWidth
          color="primary"
          onClick={() => handleClearForm()}
          className={classes.resetButton}
        >
          {t('Išvalyti skaičiavimo duomenis')}
        </Button>

        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={() => handleSaveForm()}
          // className={classes.resetButton}
        >
          {t('Išsaugoti')}
        </Button>

      </div>
    )
  }

  render() {
    const {
      classes,
      types,
      versions,
      hierarchy,
      type,
      buildingType,
      pricing,
      handleChange,
      filtersOnly,
      t,
    } = this.props;

    return (
      <CommonPanel
        title={t('Statinio duomenys')}
        noPadding
      >

        <form autoComplete="off" noValidate onSubmit={e => e.preventDefault()}>
          <div className={classes.field}>
            <TextField
              // disabled
              required
              fullWidth
              select
              className={classes.textField}
              label={t('Statinių paskirties grupė')}
              onChange={this.onChange.bind(this)}
              name="type"
              value={type}
              margin="dense"
              variant="outlined"
            >
              {types ? _.map(types, type => (
                <MenuItem key={type.code} value={type.code}>
                  {type.title}
                </MenuItem>
              )) : null}
            </TextField>

            {versions && versions.length > 0 ? (
              <div>

                <TextField
                  required
                  fullWidth
                  select
                  className={classes.textField}
                  label={t('Kainyno versija')}
                  onChange={this.onChange.bind(this)}
                  name="pricing"
                  value={pricing ? pricing.code : ''}
                  margin="dense"
                  variant="outlined"
                >
                  {_.map(versions, version => (
                    <MenuItem key={version.code} value={version.code}>
                      {version.version}
                    </MenuItem>
                  ))}
                </TextField>

                <BuildingTypePicker
                  hierarchy={hierarchy}
                  buildingType={buildingType}
                  name="buildingType"
                  handleChange={handleChange}
                  open={this.state.open}
                  resetOpen={() => this.setState({open: !this.state.open})}
                />

                <div style={{paddingTop: 6}}>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    fullWidth
                    onClick={() => this.setState({ open: true })}
                  >
                    {t('Paieška')}
                  </Button>
                </div>

                {!filtersOnly ? this.renderUserInputs() : null}

              </div>
            ) : null}
            
          </div>
        </form>

      </CommonPanel>
    );
  }
}

export default compose(withStyles(styles), withTranslation())(NtkFilters);
